<template>
  <div ref="madeForm">
    <avue-form :option="optionForm" ref="form" v-model="formData">
      <template slot="_casualties">
        <el-row :gutter="20">
          <el-col :span="2">死亡:</el-col>
          <el-col :span="5">
            <el-input placeholder="" v-model="formData.input1">
              <template slot="append">人</template>
            </el-input>
          </el-col>
          <el-col :span="2">重伤:</el-col>
          <el-col :span="5">
            <el-input placeholder="" v-model="formData.input2">
              <template slot="append">人</template>
            </el-input>
          </el-col>
          <el-col :span="2">轻伤:</el-col>
          <el-col :span="5">
            <el-input placeholder="" v-model="formData.input3">
              <template slot="append">人</template>
            </el-input>
          </el-col>

        </el-row>
      </template>
    </avue-form>
  </div>
</template>

<script>
import { add, update, getDetail, getUserList } from "../api";
import { getDetail as getCheckDetail } from "@/views/dispatch-manage/check-list/api.js";
import _ from 'lodash'
import { disposeDetail, showItem, rulesInput } from '@/basic-common/util/common.js';

export default {
  components: {  },
  props: {
    transmitData: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {
      visible: false,
      title: '',
      show: false,
      loading: false,
      userList: [],
      formData: {
        list: []
      },
      optionForm: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        detail: this.isDetails(), //启用form详情样式
        labelWidth: 150,
        span: 24,
        addText: '新增检查项',
        column: [
          {
            label: "发生时间",
            prop: "planName",
            readonly: true,
            click: () => {
              this.$refs.selectCheckList.open()
            },
          },
          {
            label: "事故类型",
            prop: "checkType",
            dicData: this.$store.getters.commonDict['check_type'],
            dataType: 'string',
            type: "select",
            cascader: ['checkItemId'],
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: rulesInput(2),
          },
          {
            label: "事故地点",
            prop: "checkDate",
            type: 'date',
            rules: rulesInput(2),
          },
          {
            label: "伤亡情况",
            prop: "_casualties",
          },
          {
            label: "直接原因",
            prop: "acceptPersonId",
            maxlength: 200,
            minRows: 3,
          },
          {
            label: "责任部门",
            prop: "checkItemId",
            overHidden: true,
            multiple: true,
            dicUrl: "/api/blade-system/dept/treeByUser",
            props: {
              label: "deptName",
              value: "id"
            },
          },
          {
            label: "现场照片",
            prop: "remark",
            type: "upload",
            drag: true,
            loadText: "文件上传中，请稍等",
            span: 24,
            propsHttp: {
              res: "data",
            },
            action: "/api/blade-resource/oss/endpoint/put-file-attach",
          },
        ]
      },
      list: [],
      optionConfig: {
        columnType: this.transmitData.type,
        addBtn: false,
        align: 'center',
        height: '40vh',
        column: [
          {
            label: '检查项目',
            prop: 'itemName',
            required: true,
            disabled: true,
          },
          {
            label: '检查标准',
            prop: 'checkListStandard',
            precision: 2,
            required: true,
            disabled: true,
          },
          {
            label: '检查结果',
            prop: 'url',
            required: true,
            dicData: this.$store.getters.commonDict['area_name'],
            type: "select"
          },
          {
            label: '现场照片',
            prop: 'problemDescription',
            type: 'updata-img',
            url: '/api/produce/file-upload/uploadCheckPhoto'
          },
          {
            label: "描述",
            prop: "remark",
            type: 'textarea',
            maxlength: 200,
            span: 24,
            minRows: 3,
          },
        ]
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      const { type, id } = this.transmitData
      type !== 'add' && this.getDetail(id)
      // 获取人员
      getUserList().then(({ data }) => {
        this.userList = data
        this.findObject(this.optionForm.column, 'acceptPersonId').dicData = data
        this.findObject(this.optionForm.column, 'inspectorIds').dicData = data
      })
    },
    //提交
    async submitForm () {
      const list = this.formData.list
      const { type } = this.transmitData
      if (!list.length) {
        return this.$message.error('请录入表格数据并验证必填项')
      }
      const subFormValidate = await this.$refs.formTable.getValidate()
      this.$refs.form.validate((valid, done) => {
        if (valid && subFormValidate) {
          if (type == 'add') {
            add(this.formData).then(({ data }) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
            }).finally(() => {
              done()
            })
          } else {
            update(this.formData).then(({ data }) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
            }).finally(() => {
              done()
            })
          }
        } else {
          done()
          this.$message.error('错误, 请验证必填项并录入符合规则的数据')
        }
      })
    },
    // 回显信息初始化
    getDetail (id) {
      this.loading = true
      getDetail(id).then(res => {
        this.formData = res.data.data
        // 特殊处理详情 主表和子表， 禁用问题，悬浮提示问题。
        const topTier = this.$refs.madeForm
        this.isDetails() && disposeDetail(topTier)
        this.isDetails() && disposeDetail(topTier, 'table-details')
      }).finally(() => {
        this.loading = false
      })

    },
    // 是否是详情
    isDetails () {
      return this.transmitData.type && this.transmitData.type == 'view'
    },
    //带出检查项
    replaceCheckList (item) {
      console.log(item.list, 'list098', item);
      this.$set(this.formData, 'list', item.list)
    },
    replace (row) {
      const replaceKey = ['planNumber', 'planName', 'checkType']
      replaceKey.forEach(item => {
        this.$set(this.formData, item, row[item])
      });
    }
  }
}
</script>
<style scoped lang="scss">
.title {
  margin: 10px 0;
  font-size: 20px;
  color: #363636;
}
</style>
